import cntl from "cntl";
import React from "react";
import PropTypes from "prop-types";
import Chevron from "../../../Buttons/Chevron";
import useNumberInputData from "./useNumberInputData";

const cntlNumberInput = ({ disabled, className }) => cntl`
  ${className}
  flex 
  justify-center 
  items-center 
  border 
  ${disabled ? "border-gray-150 bg-gray-100" : "border-gray-150 bg-lightGreen"}
  pl-4
  rounded 
  text-gray-300 
  pl-2 
  pr-2
`;

const cntlInputStyles = ({ disabled }) => cntl`
  ${!disabled ? "bg-lightGreen" : "bg-gray-100"}
  text-gray-300
  text-md
`;

const NumberInput = ({
  onChange,
  value,
  text,
  disabled,
  className,
  minValue,
}) => {
  const { inputRef, calculateInputWidth, focusInput, handleKeyDown } =
    useNumberInputData({ disabled, onChange, value });

  return (
    <button
      type="button"
      onClick={focusInput}
      style={{
        opacity: disabled ? ".5" : "1",
      }}
      className={cntlNumberInput({ disabled, className })}
    >
      <input
        ref={inputRef}
        disabled={disabled}
        className={cntlInputStyles({ disabled })}
        style={{
          height: "38px",
          width: calculateInputWidth(),
        }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      {text && <p className="mr-4 text-md text-gray-300">{text}</p>}

      <div className="flex flex-col">
        <button
          disabled={disabled}
          style={{ height: "19px" }}
          className="flex items-center justify-center"
          type="button"
          onClick={() => onChange((Number(value) + 1).toString())}
          aria-label="increase occurrences"
        >
          <Chevron
            rotate="270"
            color="#757575"
            chevronSizes={{ width: "8px", height: "8px" }}
          />
        </button>
        <button
          disabled={disabled}
          style={{ height: "19px" }}
          className="flex items-center justify-center"
          type="button"
          onClick={() => {
            if (Number(value) - 1 >= minValue)
              onChange((Number(value) - 1).toString());
          }}
          aria-label="decrease occurrences"
        >
          <Chevron
            rotate="90"
            color="#757575"
            chevronSizes={{ width: "8px", height: "8px" }}
          />
        </button>
      </div>
    </button>
  );
};

NumberInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  minValue: PropTypes.number,
};

NumberInput.defaultProps = {
  onChange: () => {},
  value: "",
  text: "",
  disabled: false,
  className: "",
  minValue: 1,
};

export default NumberInput;
